module.exports = __webpack_public_path__ + "static/tulsa-1-11588402ac90463c0360c9a613bfbbc0.jpg";